var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"university-list-banner pbottom50"},[_c('img',{attrs:{"src":require("assets/images/learn/university-list-bannerImg.jpg"),"alt":""}}),_c('div',[_vm._v("老年大学")])])
}]

export { render, staticRenderFns }